import React from 'react'
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionItem as Item } from '@szhsin/react-accordion';
import KeyboardArrowDownIcon from 'assets/icons/KeyboardArrowIcon';

function CSRWorkshopTraining() {
  const { t } = useTranslation();

  const AccordionItem = ({ header, order, ...rest }) => {
    return (
      <Item
        {...rest}
        header={({ state: { isEnter } }) => (
          <div className='flex flex-row justify-between gap-6 md:gap-8 xl:gap-10'>
            <div>
              <p className='font-bold text-sm sm:text-lg md:text-2xl xl:text-3xl'>{header}</p>
            </div>
            <div>
              <KeyboardArrowDownIcon
                className={`h-4 md:h-6 xl:h-8 w-4 md:w-6 xl:w-8 ml-auto fill-black transition-transform duration-200 ease-out ${isEnter && "rotate-180"}`}
              />
            </div>
          </div>
        )}
        className={''}
        buttonProps={{
          className: ({ isEnter }) =>
            `w-full sm:p-4 text-left`
        }}
        contentProps={{
          className: "transition-height duration-200 ease-out"
        }}
        panelProps={{ className: "sm:p-4" }}
        initialEntered={true}
      />
    )
  };

  const csr_contents = [
    {
      title: 'Aligning CSR with the Sustainable Development Goals (SDGs)',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/413c48f8b516892d4f155eb30042ed573af8dd5832d8a11c0a8daf2bb6044407628144b8bce12a2c14b9eb9f820fa0ccbb3dcacb195851cc933fb30b6b1ea4e3220812446fbc1ba24f548707586c0e1f21160710a148b6f7f205b8dba7cc331016c00e3bfc06391c625bbf24d431543f660ee28c187216f63ad9/file-1740381392268.png',
      descriptions: [
        'Understanding the 17 SDGs and their relevance to business.',
        'Mapping corporate CSR initiatives to specific SDG targets.',
        'Case studies of successful SDG-aligned CSR programs.'
      ]
    },
    {
      title: 'Implementing CSR Based on ISO 26000 Guidelines',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/047baae7c976f104f183f0d7d0eb03062d4dba101626c26f0b99b942dbc25d17ff877c4631474a462c502dfee6eb8e539cee2a265ebcbbfbf46edf6e09984630fc8f4f9c3ba493cae87cc79dd36c53e800835b0586b5c660f989021d185de20cc17d2df1730d657a24ec434919359f8502c44cad43ca1ead6d84/file-1740381834133.png',
      descriptions: [
        'Core principles and subjects of ISO 26000.',
        'Practical application of ISO 26000 for businesses.',
        'Ensuring compliance with international CSR standards.'
      ]
    },
    {
      title: 'Effective Planning for Community Development Programs with Sustainable Impact',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/7cd6e769057ffdf7a1decf54db145efd0250354f37b0f8c05da0fb79328032ab363dccd73cfc1df3dc681ddafcb43dde311b0b9db33f08bec199cdbc584b9c9a089df272445cec1bc8c21cb558f05cdabe0811af1620367c2ecf3f1d605393cf173d858001ac13aec77237a895b0c0d03c1ced6208f55af072d9/file-1740381674261.png',
      descriptions: [
        'Principles of sustainable development in CSR.',
        'Designing programs that create long-term benefits for communities.',
        'Stakeholder engagement strategies for lasting impact.'
      ]
    },
    {
      title: 'Organisational Governance for Community-Based Organisations (CBOs) as CSR Beneficiaries',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/3cdd6250a7abe6da7dfe648d896d4408bd6b5ea77cb8ab2e2badc400418103d8b767595185bcb3ad435ece80a5994990236644ca01402e475f09db89bdb6d6ee90de8a70d5dacb6a9c1e650ce8ed2ee14861b2696e967f35372fef1e6e56a98cd1e40836d83a0c4f96edd40e707e95bc3c2dfe714b3c379a91ea/file-1740382205604.png',
      descriptions: [
        'Strengthening the governance structure of CSR-funded community organizations.',
        'Capacity-building for sustainable operations beyond CSR support.',
        'Accountability, transparency, and ethical governance.'
      ]
    },
    {
      title: 'Developing an Exit Strategy for CSR Programs to Ensure Beneficiaries’ Independence',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1075c2b3b195d2ab200adea4228a2580ac7a0f3d0e88c20905d3f6edbf25f1e45d2f0fa0636233dc4327939a3d2a46bb2ba530fb933bea5879532c52c11e7bec93b2a32bd872732b304e38dc3107801437946b57979510b5d9ef62c58004d7d00775eb64ca43e5dde5160ff467426705b54cd8f2376a11369ac6/rez-file-1740642570651.png',
      descriptions: [
        'Preparing communities to sustain initiatives post-CSR support.',
        'Identifying funding alternatives and partnerships for continuity.',
        'Case studies of successful CSR exit strategies.'
      ]
    },
    {
      title: 'Measuring Social Return on Investment (SROI) for CSR Programs',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/b38a8a865ece997bb334abe77d0ab4dc64e2f43a8b4d5141caa71ef595c2fd84e72765052cc976c91e52a5a3e1ac5377975782b43be3a546644efcbb635ac274250b4cced662323c73e6174454beb8cfa96a936759e9202743f0a26b495593322195fb80c4479411cf048c954222637980e024ee7a03cc34a434/file-1740382176371.png',
      descriptions: [
        'Understanding SROI and its importance in CSR decision-making.',
        'Tools and methodologies for quantifying CSR impact.',
        'Practical exercises on calculating SROI.'
      ]
    },
    {
      title: 'Understanding and Managing Social License to Operate (SLO)',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0bddabb0151bfef9e435f03d579fe683b868ea6858ef0902856100ad1106190cb06d761ecdc8ae148f6a94b6ae87a42b4fe6a5a01f494c63e9bf365f4f41ba2852d3eac29a2f55226970feb9d6d2a90eb6a9ecca173842a9927cb0447b44c49f3acc9c90dd79be89bdf76f089db330d8987e71a27ec7c103877e/file-1740382405888.png',
      descriptions: [
        'Importance of community trust in business operations.',
        'Strategies for gaining and maintaining social license.',
        'Case studies of companies with strong vs. weak SLO.'
      ]
    },
    {
      title: 'Conducting Effective Social Mapping to Identify Strategic Beneficiaries',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/698d4d3dc2e810b2f6730dd215472efdc8add658202f7acd73c0c4950629d05b7138ff9cf7016ff44196a0033dae10bea194100dcb993932fd77d28fe2afb1d93a9460a6c8bbe312aa18a9e215b237151d32ab2cf458f86c495c8a04f32d420e5a67127c9a92feac5d8741a6d9d404d6ad29184985439c1735fe/file-1740381545660.png',
      descriptions: [
        'Tools and techniques for social mapping.',
        'Identifying communities and stakeholders who impact business sustainability.',
        'Using data-driven approaches for targeted CSR planning.'
      ]
    },
    {
      title: 'Corporate-Community Partnerships for Shared Value Creation',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/331f80251b5230535c2ed48480124a5eaa014c81dba74f7dfd0b1bbd6daa338d5fae12375b0cd7b34dd653c18ac62c78c99ae91c86801091a66199bd4878829b0aa398e5137211c0467e51954fee2ee9e9b4ad9b70eda1b7015899fe080b3ee9ef6a6ba2be0913a2be4db0c1012a2201d2b735c2b83db00fe547/file-1740381576469.png',
      descriptions: [
        'Moving beyond philanthropy to create mutual benefits.',
        'Best practices in sustainable corporate-community collaboration.',
        'Case studies of successful shared-value initiatives.'
      ]
    },
    {
      title: 'Integrating ESG (Environmental, Social, and Governance) Factors into CSR Strategies',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4e9a8fa3c7f6f9e63dddc37ce1d85869ff457f585a2d1b57a62b35eb04618bbbd8bfa09fc701383f035ce32245d0c54e942b4f025ac0929f0c1dc808a63ef3f47d48b2bb56ce9268a522cb79799dd812bee50d9a4269ea498a509d986df4fb2f6bba6f02c0495c20c14ef48ca49f01c2f7385b81b3bbb3b472df/file-1740381896745.png',
      descriptions: [
        'Understanding the link between CSR and ESG frameworks.',
        'Aligning CSR efforts with global sustainability standards.',
        'Reporting and compliance with ESG guidelines.'
      ]
    },
    {
      title: 'Communicating CSR Effectively: Transparency, Reporting, and Branding',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/db1bfc59a8bd7c790becce5e0f614d587b6c8952e4a4066f07a31b74af367ed3825636dcd365898784104b88191f797f6db52bebdb78d7e4fcb8b7aaf31f6c213932eb09a921cf33de658adf5fe446ba8c4fef328a0459119e41349505def9838f2a6ee22c898587d8bb40db7011283e4c1eec7097b1bfc72884/file-1740381503264.png',
      descriptions: [
        'Best practices in CSR reporting and impact communication.',
        'How CSR enhances corporate reputation and stakeholder trust.',
        'Leveraging digital media for CSR storytelling.'
      ]
    },
    {
      title: 'Crisis Management and CSR: Leveraging CSR for Resilience and Business Continuity',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0e555d40d31249cc1a586bc4027f45c16b4a5f761ff37778a6d5b8222a2cdfb2660ea376942cb36a3ae2440522eaa5aecd8f5e5f2ff602a387585558cf2ebd1eb6b05099b8e5c78dd50ea04ec1a45e04961fa4b18b8b4fbf412d62489dab81a72210c329e44da172c4aad164984851c4665e86c71b7811d662ef/file-1740381615131.png',
      descriptions: [
        'CSR’s role in disaster response and crisis mitigation.',
        'Case studies on how companies use CSR to respond to crises.',
        'Developing a CSR-driven crisis management strategy.'
      ]
    },
    {
      title: 'Ethical Leadership and CSR: Creating a Culture of Corporate Responsibility',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/b046ab03c4620d39a61d585c726cf898632c5704d86f0b68896e351a4614b20ab346ffcd6a778d99e623275f896bfae915a91d5aa71a6bf4867f2005b2e6754bdddeb2587ed52c8eea906e9ae4ce7c97ad36d47f42957e40e52e9f956e0dd9f6107fb861a54109ae0056b2de87a600f8741ca1cd878e1651d6ab/file-1740381799408.png',
      descriptions: [
        'Role of leadership in driving CSR initiatives.',
        'Ethical decision-making and corporate responsibility.',
        'Case studies on responsible leadership in CSR.'
      ]
    },
    {
      title: 'Employee Engagement in CSR: Building a Purpose-Driven Workforce',
      img_url: 'https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4160c980848fa453d54903a61346a92c267a13fd46868ad82f6871c1b5e1518e4fb5308e006202a2962dee932afb0a41289ae0ddab391506e831ccdfad307ceb511db400558c980381110580735b6d1a8107d61e88f1eac504010bfc714118f2d29e821542611fff0697659b69dd6b14a2a6278f1f184b397344/file-1740381714472.png',
      descriptions: [
        'Strategies for involving employees in CSR programs.',
        'Benefits of employee volunteerism and corporate social involvement.',
        'Measuring the impact of employee-driven CSR initiatives.'
      ]
    },
  ]

  return (
    <div>
      <section>
        <div className='relative'>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/25708212d8c5e137294fe7ba0ad7baae4ce269c444086d80c0cdc85e602a4f8e5184556e4a039c3d9b54f528894634179c4925716df56a1400eb9db3ef2ebed69675bd481f55d5c33cec7892e2dd4b7f0d3025a58549e877d0a6b4d6afb885378ef627df505e501bc008c01cfca3a2046fd1ecd43c1afcacd8a4/rez-file-1739775349512.jpg" alt="main" className='w-full max-h-40 sm:max-h-80 object-cover object-bottom' />
          <div className='absolute top-0 bottom-0 left-0 right-0 bg-app-orange/10 text-white'>
            <div className='app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8'>
              <p className='text-xl/[2rem] sm:text-3xl/[4rem] lg:text-5xl/[5rem] max-w-6xl px-8 font-semibold sm:font-bold text-center app-animation-translate-start'>CSR Workshop & Inhouse Training Topics</p>
            </div>
          </div>
        </div>
      </section>

      <section className='bg-app-dark-gray/10'>
        <div className='app-main-container space-y-8'>
          <p className='py-3 md:py-6 text-base/[1.75rem] md:text-lg/[2rem] xl:text-xl/[2.5rem] text-center app-animation-translate-start'>
            Our <b>Corporate Social Responsibility (CSR) Workshops & In-House Training</b> programs are designed to help organizations <b>develop and implement impactful CSR strategies</b> that align with business goals while driving positive social and environmental change. Led by <b>industry experts</b>, our interactive training sessions equip teams with the <b>knowledge, tools, and best practices</b> to enhance CSR initiatives and create meaningful stakeholder engagement.
          </p>
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container space-y-8 pb-10 md:pb-14'>
          <p className='pt-3 pb-2 md:pt-6 md:pb-4 text-xl md:text-2xl xl:text-4xl font-bold text-app-orange text-center app-animation-translate-start'>
            CSR Workshop & Inhouse Training Topics
          </p>
          <div className='grid grid-cols-1 gap-10 md:gap-14 pt-2 pb-6 md:pt-4 md:pb-12'>
            {csr_contents.map((content, i) => {
              return (
                <div key={i} className='flex flex-row-reverse bg-app-dark-gray/10 rounded-lg app-animation-translate-start'>
                  <img className="w-1/2 aspect-video object-center object-cover rounded-r-lg" src={content.img_url} alt={content.title} />
                  <Accordion className='w-1/2 p-4 flex items-center' transition transitionTimeout={200}>
                    <AccordionItem header={content.title} key={i} order={i}>
                      <ul className='mt-2 ml-3 sm:ml-6 flex flex-col items-start text-sm sm:text-base md:text-lg xl:text-xl space-y-2'>
                        {content.descriptions.map((description, k) => {
                          return (
                            <li key={k} className='px-2 list-disc'>
                              {description}
                            </li>
                          )
                        })}
                      </ul>
                    </AccordionItem>
                  </Accordion>
                </div>
              )
            })}
          </div>
          <div className='bg-app-dark-gray/10 space-y-4 p-4 sm:p-6 rounded-lg app-animation-translate-start'>
            <p className='font-bold text-base sm:text-lg xl:text-xl'>Duration, Content, Format, Audience:</p>
            <p className='text-sm sm:text-base xl:text-lg'>Can be customised based on the Clients’ needs and Global/National ESG related regulations/standards development.</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default CSRWorkshopTraining